module.exports = __webpack_public_path__ + "media/images/pic/kitty-group-light-94e8d638fec2df7a69ae2b30ac167b30.png";